import { Node, mergeAttributes } from '@tiptap/core';

const JotformEmbed = Node.create({
  name: 'jotformEmbed',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      formId: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-form-id'),
        renderHTML: (attributes) => {
          if (!attributes.formId) return {};
          return { 'data-form-id': attributes.formId };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div.jotform-embed',
        getAttrs: (element) => {
          const formId = element.getAttribute('data-form-id');
          return formId ? { formId } : false;
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { class: 'jotform-embed' })];
  },

  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement('div');
      dom.className = 'jotform-embed jotform-embed--editor';
      dom.setAttribute('data-form-id', node.attrs.formId || '');
      dom.setAttribute('contenteditable', 'false');

      const card = document.createElement('div');
      card.className = 'jotform-embed-placeholder';
      card.innerHTML = `
        <span class="jotform-embed-placeholder__icon" aria-hidden="true">📋</span>
        <span class="jotform-embed-placeholder__label">Jotform form #${node.attrs.formId || ''}</span>
      `;
      dom.appendChild(card);

      return {
        dom,
        update(updatedNode) {
          if (updatedNode.type.name !== 'jotformEmbed') return false;
          dom.setAttribute('data-form-id', updatedNode.attrs.formId || '');
          const label = card.querySelector('.jotform-embed-placeholder__label');
          if (label) {
            label.textContent = `Jotform form #${updatedNode.attrs.formId || ''}`;
          }
          return true;
        },
      };
    };
  },

  addCommands() {
    return {
      insertJotformEmbed:
        (formId) =>
        ({ commands }) =>
          commands.insertContent({
            type: this.name,
            attrs: { formId },
          }),
    };
  },
});

export default JotformEmbed;
